var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoices = function SvgInvoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "m7 20-3 2V2h16v20l-3-2-2.5 2-2.5-2-2.5 2zM8 7h8M8 11h8M8 15h4"
  })));
};
export default SvgInvoices;